export { default } from './color';

//# sourceMappingURL=index.js.map